import React from "react";

const SvgCheckmarkLong = props => <svg width={15} height={15} viewBox="0 0 15 15" fill="none" {...props}><path d="M1 9.34783L5.33333 13L14 1" stroke="currentColor" strokeWidth={2} /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/checkmark-long_f0787c.svg";
export { SvgCheckmarkLong as ReactComponent };